import React from 'react'
import { Link } from 'react-router-dom'
import { footerSocial } from '../data'

import { LuMapPin, LuPhone, LuCalendarClock, BiLogoWhatsapp, LuCheck, LuCheckCheck, LuCheckSquare, LuUserCircle, LuShare, LuShare2 } from '../assets/icons/vander'

export default function Footer() {
  return (
    <>
        <footer className="footer bg-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-12" style={{padding:40}}>
                         <h4 className="text-light footer-head"><LuMapPin className='text-primary' /> Domicilio</h4>
                        <p className="mt-2">Edificio Celtara Piso No. 9 <br />Av. P. Rio San miguel 39, Proyecto Rio Sonora Hermosillo XXI, 83280 Hermosillo, Sonora, México.</p>
                       <br />
                        <h4 className="text-light footer-head"><LuPhone className='text-primary' /> Teléfono de oficina</h4>
                         <p className="mt-2">(6623) 60.44.91</p>
                         <br />
                         <Link to="https://wa.me/+5216623604491?text=Información CNRC" target='_blank' ><h4 className="text-light footer-head"> <BiLogoWhatsapp className='text-primary' size={20} />  Enlace Whatsapp</h4></Link>
                         <br />
                          <h4 className="text-light footer-head"><LuCalendarClock className='text-primary' /> Horarios de atención</h4>
                         <p className="mt-2">Lunes a Viernes de 8.00 am - 6.00 pm<br /> Sábado de 9.00 am - 3.00 pm <br /> Domingo permance cerrado</p>  
                         <br />
                         <h4 className="text-light footer-head"><LuShare2 className='text-primary' /> Redes sociales</h4>
                         <div className="col-sm-6 mt-3 ">
                                                 <ul className="list-unstyled text-left social-icon social mb-0">
                                                     {footerSocial.map((item,index)=>{
                                                         let Icon = item.icon
                                                         return(
                                                             <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className=" align-middle"><Icon size={18}/></i></Link></li>
                                                         )
                                                     })}
                                                 </ul>
                                             </div>   
                  </div>
                    
                    <div className="col-lg-8 col-md-4 col-12" style={{padding:40}}>
                        <h4 className="text-light footer-head"><LuMapPin className='text-primary' /> Ubicación</h4>
                        <div className='text-left'>
                            <iframe title='mapa' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3487.3461016121014!2d-110.9616198!3d29.065916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ce852348c9d94b%3A0x61ec4cf3c74b7e1b!2sCeltara%20Medical%20%26%20Professional%20Center!5e0!3m2!1ses-419!2smx!4v1754854212869!5m2!1ses-419!2smx" width="900" height="450" style={{border:0}}  loading="lazy"></iframe>
                        </div>
                         
                    </div>

                   
                </div>
            </div>
        </footer>
      
        <footer className="footer bg-footer footer-bar">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="text-center">
                            <p className="mb-0">© {new Date().getFullYear()} Desarrollado por <Link className="text-primary" to="https://vespertia.com/" target='_blank'>Vespertia</Link>.</p>
                        </div>
                    </div>           
                </div>
            </div>
        </footer>
    </>
  )
}
